// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Ocorrencias_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /ocorrencias/delete
 *
 * Deletes an occurrence/note by ID.
 */
import { registerContract } from './validate'

export interface Ocorrencias_DeleteInput {
ocorrencia_id: string
}

registerContract('Ocorrencias_DeleteInput', {
  ocorrencia_id: { type: 'string',  required: true },
})
